document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(".enostos-scroll-line");
  var indicator = document.getElementById("scrollIndicator");
  var svg       = document.getElementById("enostosSvg");
  var path      = document.getElementById("enostosPathActive");

  if (!container || !svg || !path) return;

  var pathLength   = 0;
  var SYMS         = [];
  var symbolsReady = false;

  // ── Image depot ───────────────────────────────────────────────────────────
  var depotSlides = document.querySelectorAll(
    '[id$="__slideshow_knpfVM"] slideshow-slide img'
  );
  var shellImageSource   = depotSlides[0] || null;
  var swallowImageSource = depotSlides[1] || null;
  var groveImageSource   = depotSlides[2] || null;

  var shellImageClone   = null;
  var swallowImageClone = null;
  var groveImageClone   = null;

  // ── Border constants ──────────────────────────────────────────────────────
  var BORDER_COLOR  = '#1D1C1A';
  var OUTER_PAD     = 8;    // px outside image edge — outer line
  var INNER_PAD     = 3;    // px outside image edge — inner line (small bg gap between line and image)
  var OUTER_STROKE  = 1.2;  // outer line thickness — tweak here
  var INNER_STROKE  = 3;  // inner line thickness — tweak here
  var OUTER_AMP     = 3.0;  // outer wave height in px
  var INNER_AMP     = 3.5;  // inner wave height in px
  var OUTER_FREQ    = 0.055;
  var INNER_FREQ    = 0.042;

  // ── Wavy edge point generator ─────────────────────────────────────────────
  function wavyEdgePoints(axis, from, to, fixed, dir, amp, freq, seed) {
    var length = Math.abs(to - from);
    var steps  = Math.max(6, Math.round(length * 0.16));
    var pts    = [];
    for (var i = 0; i <= steps; i++) {
      var t    = i / steps;
      var pos  = from + t * (to - from);
      var dist = t * length;
      var w = amp * dir * (
        Math.sin(dist * freq + seed * 2.3) * 0.6 +
        Math.sin(dist * freq * 1.7 + seed * 5.1) * 0.4
      );
      pts.push(axis === 'x' ? [pos, fixed + w] : [fixed + w, pos]);
    }
    return pts;
  }

  // ── Build a closed wavy rect path ─────────────────────────────────────────
  // Returns SVG path string. All coords in SVG canvas space (image top-left = canvasOff,canvasOff).
  function buildWavyRect(imgW, imgH, pad, amp, freq, seed, dir, canvasOff) {
    var x0 = canvasOff - pad, y0 = canvasOff - pad;
    var x1 = canvasOff + imgW + pad, y1 = canvasOff + imgH + pad;
    var waveSign = 1; // always wave outward from rect center

    var top    = wavyEdgePoints('x', x0, x1, y0, -waveSign, amp, freq, seed + 0);
    var right  = wavyEdgePoints('y', y0, y1, x1,  waveSign, amp, freq, seed + 1);
    var bottom = wavyEdgePoints('x', x1, x0, y1,  waveSign, amp, freq, seed + 2);
    var left   = wavyEdgePoints('y', y1, y0, x0, -waveSign, amp, freq, seed + 3);

    var allPts = top.concat(right.slice(1)).concat(bottom.slice(1)).concat(left.slice(1, -1));
    if (dir === -1) allPts.reverse();

    // Rotate to start at top-center
    var startIdx = Math.round(top.length / 2);
    if (dir === -1) startIdx = allPts.length - startIdx;
    startIdx = ((startIdx % allPts.length) + allPts.length) % allPts.length;
    var pts = allPts.slice(startIdx).concat(allPts.slice(0, startIdx));

    var n = pts.length;
    var d = 'M' + pts[0][0].toFixed(2) + ' ' + pts[0][1].toFixed(2);
    for (var i = 0; i < n; i++) {
      var p0 = pts[(i - 1 + n) % n], p1 = pts[i];
      var p2 = pts[(i + 1) % n],     p3 = pts[(i + 2) % n];
      var t  = 0.35;
      d += ' C' +
        (p1[0] + (p2[0] - p0[0]) * t / 3).toFixed(2) + ',' +
        (p1[1] + (p2[1] - p0[1]) * t / 3).toFixed(2) + ' ' +
        (p2[0] - (p3[0] - p1[0]) * t / 3).toFixed(2) + ',' +
        (p2[1] - (p3[1] - p1[1]) * t / 3).toFixed(2) + ' ' +
        p2[0].toFixed(2) + ',' + p2[1].toFixed(2);
    }
    return d + ' Z';
  }

  // ── Clone a depot image — returns a standalone SVG element ───────────────
  // The SVG contains: clipPath (wavy inner shape) + <image> clipped to it +
  // outer stroke + inner stroke. All in one coordinate system — no positioning mismatch.
  function cloneDepotImage(source) {
    if (!source) return null;
    source.style.opacity = '0';

    // Wrapper object — mimics the old wrapper div interface
    var handle = {
      _svg:   null,   // the floating SVG element in the container
      _src:   source.currentSrc || source.src,
      _bW:    0,
      _bH:    0,
      _ready: false,
    };

    // We can't know dimensions until the image loads and the wrapper is sized.
    // Create a hidden img to detect natural dimensions.
    var probe = new Image();
    probe.onload = function () {
      handle._naturalW = probe.naturalWidth;
      handle._naturalH = probe.naturalHeight;
    };
    probe.src = handle._src;

    return handle;
  }

  // ── Build / rebuild the floating SVG for one image ────────────────────────
  function attachFloatingSvg(handle, renderW, renderH) {
    if (handle._bW === renderW && handle._bH === renderH) return;

    // Remove old SVG if resizing
    if (handle._svg && handle._svg.parentNode) {
      handle._svg.parentNode.removeChild(handle._svg);
    }

    var ns   = 'http://www.w3.org/2000/svg';
    var off  = OUTER_PAD + Math.ceil(OUTER_AMP) + 2;
    var canW = renderW + off * 2;
    var canH = renderH + off * 2;
    var uid  = 'efc-' + Math.random().toString(36).slice(2, 8);

    var floatSvg = document.createElementNS(ns, 'svg');
    floatSvg.setAttribute('width',   canW);
    floatSvg.setAttribute('height',  canH);
    floatSvg.setAttribute('viewBox', '0 0 ' + canW + ' ' + canH);
    floatSvg.style.position      = 'absolute';
    floatSvg.style.pointerEvents = 'none';
    floatSvg.style.overflow      = 'visible';
    floatSvg.style.width         = canW + 'px';
    floatSvg.style.height        = canH + 'px';
    floatSvg.style.minWidth      = canW + 'px';
    floatSvg.style.minHeight     = canH + 'px';
    floatSvg.style.maxWidth      = 'none';
    floatSvg.style.opacity       = '0';

    // ── Inner wavy path ──────────────────────────────────────────────────
    var dInner = buildWavyRect(renderW, renderH, INNER_PAD, INNER_AMP, INNER_FREQ, 42, 1, off);

    // ── <image> — full rectangle, corners hidden by bg mask below ─────────
    var imgEl = document.createElementNS(ns, 'image');
    imgEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', handle._src);
    imgEl.setAttribute('href', handle._src);
    imgEl.setAttribute('x',      off);
    imgEl.setAttribute('y',      off);
    imgEl.setAttribute('width',  renderW);
    imgEl.setAttribute('height', renderH);
    imgEl.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    floatSvg.appendChild(imgEl);

    // ── Background mask — SVG even-odd compound path ───────────────────────
    // Covers image corners with page background color.
    // Outer sub-path: full SVG canvas rectangle (clockwise)
    // Inner sub-path: inner wavy shape (counter-clockwise = punches hole)
    // Even-odd fill rule fills only the ring between canvas edge and inner shape,
    // masking the image corners. No url() reference needed — pure SVG fill.
    var canvasRect = 'M0,0 L' + canW + ',0 L' + canW + ',' + canH + ' L0,' + canH + ' Z';
    // Mask clips deeper into image than the visible inner stroke line.
    // Inner stroke (dInner) sits at INNER_PAD outside image — visible gap.
    // Mask hole sits at MASK_PAD inside image — hides corners behind bg color.
    var MASK_PAD   = -4;
    var dInnerCCW  = buildWavyRect(renderW, renderH, MASK_PAD, INNER_AMP, INNER_FREQ, 42, -1, off);
    var pBg = document.createElementNS(ns, 'path');
    pBg.setAttribute('d',         canvasRect + ' ' + dInnerCCW);
    pBg.setAttribute('fill',      '#EBE0D0');
    pBg.setAttribute('fill-rule', 'evenodd');
    pBg.setAttribute('stroke',    'none');
    floatSvg.appendChild(pBg);

    // ── Inner stroke only — outer line removed ───────────────────────────
    var pInner = document.createElementNS(ns, 'path');
    pInner.setAttribute('d',               dInner);
    pInner.setAttribute('fill',            'none');
    pInner.setAttribute('stroke',          BORDER_COLOR);
    pInner.setAttribute('stroke-width',    INNER_STROKE);
    pInner.setAttribute('stroke-linecap',  'round');
    pInner.setAttribute('stroke-linejoin', 'round');
    floatSvg.appendChild(pInner);

    container.appendChild(floatSvg);

    handle._svg    = floatSvg;
    handle._pOuter = null;
    handle._pInner = pInner;
    handle._bW     = renderW;
    handle._bH     = renderH;
    handle._ready  = false;
    handle._off    = off;

    // Init dash lengths on next frame
    requestAnimationFrame(function () {
      if (!handle._ready) {
        var li = pInner.getTotalLength();
        pInner.setAttribute('stroke-dasharray',  li.toFixed(2));
        pInner.setAttribute('stroke-dashoffset', li.toFixed(2));
        pInner.setAttribute('data-len',          li.toFixed(2));
        handle._ready = true;
      }
    });
  }

  // ── Position + reveal a floating image SVG ────────────────────────────────
  function updateClonedImage(handle, pos, dir) {
    if (!handle) return;
    var W  = window.innerWidth;
    var vh = W < 750 ? document.documentElement.clientHeight : window.innerHeight;
    var bp = W < 750 ? 'mobile' : W < 1200 ? 'tablet' : 'desktop';
    var p  = pos[bp];

    var renderW = Math.round(Math.min(W * p.wf, p.maxW || 320));
    // Derive height from natural aspect ratio once known
    var renderH = renderW;
    if (handle._naturalW && handle._naturalH) {
      renderH = Math.round(renderW * handle._naturalH / handle._naturalW);
    }

    // Build/rebuild SVG if dimensions changed
    attachFloatingSvg(handle, renderW, renderH);

    if (!handle._svg) return;

    var off = handle._off || (OUTER_PAD + Math.ceil(OUTER_AMP) + 2);

    // Position the SVG so image area starts at the target coords
    // SVG top-left is `off` px above/left of image top-left
    var imgLeft = p.xf * W - renderW / 2;
    var imgTop  = p.yf * vh;
    handle._svg.style.left = (imgLeft - off) + 'px';
    handle._svg.style.top  = (imgTop  - off) + 'px';

    // Reveal progress
    var imageDocY   = p.yf * vh;
    var revealStart = Math.max(0, imageDocY - vh * 0.8);
    var revealEnd   = Math.max(revealStart + 1, imageDocY - vh * 0.4);
    var progress    = Math.max(0, Math.min(1,
      (window.scrollY - revealStart) / (revealEnd - revealStart)
    ));
    var eased = progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    var drift = bp === 'mobile' ? (1 - eased) * 30
              : bp === 'tablet' ? (1 - eased) * 40
              : (1 - eased) * 60;

    handle._svg.style.opacity   = eased.toFixed(3);
    handle._svg.style.transform = 'translateX(' + (dir * drift).toFixed(1) + 'px)';

    // Drive stroke dash animation
    if (handle._ready) {
      var li = parseFloat(handle._pInner.getAttribute('data-len'));
      handle._pInner.setAttribute('stroke-dashoffset', (li * (1 - eased)).toFixed(2));
    }
  }

  // ── Section positions ─────────────────────────────────────────────────────
  var SHELL_POS = {
    mobile:  { xf: 0.53, yf: 1.78, wf: 0.63, maxW: 260 },
    tablet:  { xf: 0.65, yf: 1.80, wf: 0.62, maxW: 460 },
    desktop: { xf: 0.58, yf: 1.77, wf: 0.22, maxW: 320 },
  };
  function initShellImage()   { shellImageClone   = cloneDepotImage(shellImageSource);   updateShellImage(); }
  function updateShellImage() { updateClonedImage(shellImageClone,   SHELL_POS,    1); }

  var SWALLOW_POS = {
    mobile:  { xf: 0.37, yf: 2.79, wf: 0.63, maxW: 260 },
    tablet:  { xf: 0.32, yf: 2.81, wf: 0.62, maxW: 460 },
    desktop: { xf: 0.41, yf: 2.77, wf: 0.22, maxW: 320 },
  };
  function initSwallowImage()   { swallowImageClone   = cloneDepotImage(swallowImageSource);   updateSwallowImage(); }
  function updateSwallowImage() { updateClonedImage(swallowImageClone, SWALLOW_POS, -1); }

  var GROVE_POS = {
    mobile:  { xf: 0.61, yf: 3.80, wf: 0.63, maxW: 260 },
    tablet:  { xf: 0.70, yf: 3.82, wf: 0.62, maxW: 460 },
    desktop: { xf: 0.59, yf: 3.71, wf: 0.22, maxW: 300 },
  };
  function initGroveImage()   { groveImageClone   = cloneDepotImage(groveImageSource);   updateGroveImage(); }
  function updateGroveImage() { updateClonedImage(groveImageClone,   GROVE_POS,    1); }

  // ── Hide symbols immediately ──────────────────────────────────────────────
  ['shell', 'swallow', 'leaf', 'human'].forEach(function (n) {
    var el = document.getElementById('sym-' + n);
    if (el) el.style.setProperty('opacity', '0', 'important');
  });

  // ── Build path ────────────────────────────────────────────────────────────
  function buildPath() {
    var W  = window.innerWidth;
    var vh = W < 750 ? document.documentElement.clientHeight : window.innerHeight;
    var bp = W < 750 ? 'mobile' : W < 1200 ? 'tablet' : 'desktop';

    var symScale = bp === 'desktop' ? 1.0 : 1.8;
    var symW     = (280 / 677) * W * symScale;
    var symH     = symW * (160.34 / 226.77);
    var circleR  = symW * 0.22;

    var symDefs = bp === 'mobile' ? [
      { name: 'shell',   xf: 0.72,  yf: 1.18 },
      { name: 'swallow', xf: 0.22,  yf: 2.18 },
      { name: 'leaf',    xf: 0.74,  yf: 3.18 },
      { name: 'human',   xf: 0.22,  yf: 4.45 },
    ] : bp === 'tablet' ? [
      { name: 'shell',   xf: 0.72,  yf: 1.30 },
      { name: 'swallow', xf: 0.28,  yf: 2.35 },
      { name: 'leaf',    xf: 0.72,  yf: 3.30 },
      { name: 'human',   xf: 0.28,  yf: 4.45 },
    ] : [
      { name: 'shell',   xf: 0.753, yf: 1.40 },
      { name: 'swallow', xf: 0.244, yf: 2.45 },
      { name: 'leaf',    xf: 0.746, yf: 3.42 },
      { name: 'human',   xf: 0.251, yf: 4.60 },
    ];

    SYMS = symDefs.map(function (s) {
      return {
        name: s.name, cx: s.xf * W, cy: s.yf * vh,
        dispX: s.xf * W - symW / 2, dispY: s.yf * vh - symH / 2,
        dispW: symW, dispH: symH, circleR: circleR,
      };
    });

    SYMS.forEach(function (s) { s.lineStopsAt = s.cy - s.circleR; });
    SYMS.forEach(function (s) {
      var svgEl = document.getElementById('sym-svg-' + s.name);
      if (!svgEl) return;
      svgEl.setAttribute('x',      s.dispX.toFixed(1));
      svgEl.setAttribute('y',      s.dispY.toFixed(1));
      svgEl.setAttribute('width',  s.dispW.toFixed(1));
      svgEl.setAttribute('height', s.dispH.toFixed(1));
    });

    var pts = bp === 'mobile' ? [
      [0.500, 0.97], [0.500, 1.02],
      [0.520, 1.05], [0.580, 1.08], [0.650, 1.12], [0.720, 1.18],
      [0.760, 1.30], [0.740, 1.52], [0.680, 1.68], [0.580, 1.82], [0.480, 1.96],
      [0.360, 2.08], [0.240, 2.14], [0.220, 2.18],
      [0.180, 2.28], [0.160, 2.50], [0.200, 2.68], [0.340, 2.82], [0.460, 2.96],
      [0.580, 3.08], [0.680, 3.14], [0.740, 3.18],
      [0.780, 3.30], [0.760, 3.52], [0.700, 3.68], [0.600, 3.82], [0.500, 3.96],
      [0.380, 4.12], [0.280, 4.28], [0.220, 4.40], [0.220, 4.45],
    ] : bp === 'tablet' ? [
      [0.500, 0.93], [0.500, 1.02],
      [0.530, 1.08], [0.640, 1.18], [0.710, 1.26], [0.720, 1.30],
      [0.730, 1.42], [0.690, 1.58], [0.630, 1.72],
      [0.550, 1.85], [0.460, 1.98], [0.360, 2.10], [0.290, 2.24], [0.280, 2.35],
      [0.260, 2.47], [0.290, 2.60], [0.370, 2.72],
      [0.460, 2.83], [0.540, 2.95], [0.620, 3.07], [0.700, 3.20], [0.720, 3.30],
      [0.710, 3.42], [0.660, 3.56], [0.600, 3.69],
      [0.520, 3.81], [0.440, 3.97], [0.360, 4.12], [0.290, 4.32], [0.280, 4.45],
    ] : [
      [0.500, 0.93], [0.500, 1.02],
      [0.537, 1.10], [0.650, 1.22], [0.724, 1.32], [0.753, 1.40],
      [0.739, 1.52], [0.687, 1.67], [0.628, 1.80],
      [0.544, 1.93], [0.455, 2.07], [0.352, 2.20], [0.278, 2.32], [0.244, 2.45],
      [0.254, 2.58], [0.292, 2.72], [0.372, 2.84],
      [0.470, 2.94], [0.547, 3.06], [0.632, 3.19], [0.706, 3.31], [0.746, 3.42],
      [0.721, 3.54], [0.668, 3.68], [0.609, 3.80],
      [0.520, 3.92], [0.446, 4.09], [0.352, 4.26], [0.284, 4.44], [0.251, 4.60],
    ];

    var pixPts = pts.map(function (p) { return [p[0] * W, p[1] * vh]; });

    function catmullRom(pts) {
      var d = 'M' + pts[0][0].toFixed(2) + ' ' + pts[0][1].toFixed(2);
      for (var i = 0; i < pts.length - 1; i++) {
        var p0 = pts[Math.max(i - 1, 0)], p1 = pts[i];
        var p2 = pts[i + 1], p3 = pts[Math.min(i + 2, pts.length - 1)];
        var t  = 0.4;
        d += ' C' +
          (p1[0] + (p2[0] - p0[0]) * t / 3).toFixed(2) + ' ' +
          (p1[1] + (p2[1] - p0[1]) * t / 3).toFixed(2) + ' ' +
          (p2[0] - (p3[0] - p1[0]) * t / 3).toFixed(2) + ' ' +
          (p2[1] - (p3[1] - p1[1]) * t / 3).toFixed(2) + ' ' +
          p2[0].toFixed(2) + ' ' + p2[1].toFixed(2);
      }
      return d;
    }

    var pageH = document.documentElement.scrollHeight;
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + pageH);
    container.style.height = pageH + 'px';
    path.setAttribute('d', catmullRom(pixPts));
    pathLength = path.getTotalLength();
    path.style.strokeDasharray  = pathLength;
    path.style.strokeDashoffset = pathLength;
    path.style.visibility       = 'visible';

    var sampleD = 20;
    SYMS.forEach(function (s) {
      s.pathLenAtEdge = getLengthAtY(s.lineStopsAt);
      var ptAtEdge    = path.getPointAtLength(s.pathLenAtEdge);
      var revealOffset   = bp === 'mobile' ? 0.99 : bp === 'tablet' ? 0.95 : 1.10;
      var revealDuration = bp === 'mobile' ? 0.45 : bp === 'tablet' ? 0.65 : 1.00;
      s.revealStart = Math.max(ptAtEdge.y - vh * revealOffset, 0);
      s.revealEnd   = s.revealStart + vh * revealDuration;
      var ptIn1 = path.getPointAtLength(Math.max(s.pathLenAtEdge - sampleD, 0));
      var ptIn2 = path.getPointAtLength(Math.max(s.pathLenAtEdge - 2, 0));
      s.entryAngle = Math.atan2(ptIn2.y - ptIn1.y, ptIn2.x - ptIn1.x);
      var arrLen = getLengthAtY(s.cy);
      var ptOut1 = path.getPointAtLength(Math.min(arrLen + 2, pathLength));
      var ptOut2 = path.getPointAtLength(Math.min(arrLen + sampleD, pathLength));
      s.exitAngle = Math.atan2(ptOut2.y - ptOut1.y, ptOut2.x - ptOut1.x);
    });

    ensureLineMask();
    symbolsReady = true;
  }

  // ── Line mask ─────────────────────────────────────────────────────────────
  function ensureLineMask() {
    var defs = svg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      svg.insertBefore(defs, svg.firstChild);
    }
    if (document.getElementById('line-mask')) return;
    var mask = document.createElementNS('http://www.w3.org/2000/svg', 'mask');
    mask.setAttribute('id', 'line-mask');
    mask.setAttribute('maskUnits', 'userSpaceOnUse');
    var bg = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    bg.setAttribute('x', '-99999'); bg.setAttribute('y', '-99999');
    bg.setAttribute('width', '199999'); bg.setAttribute('height', '199999');
    bg.setAttribute('fill', 'white');
    mask.appendChild(bg);
    ['shell', 'swallow', 'leaf', 'human'].forEach(function (n) {
      var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('id', 'lm-' + n);
      c.setAttribute('fill', 'black');
      c.setAttribute('cx', '0'); c.setAttribute('cy', '0'); c.setAttribute('r', '0');
      mask.appendChild(c);
    });
    defs.appendChild(mask);
    path.setAttribute('mask', 'url(#line-mask)');
  }

  function updateLineMask() {
    if (!pathLength) return;
    var offset = parseFloat(path.style.strokeDashoffset) || pathLength;
    var drawn  = pathLength - offset;
    var tipY   = drawn > 0 ? path.getPointAtLength(Math.min(drawn, pathLength)).y : -9999;
    SYMS.forEach(function (s) {
      var c = document.getElementById('lm-' + s.name);
      if (!c) return;
      if (tipY >= s.lineStopsAt - 2) {
        c.setAttribute('cx', s.cx.toFixed(1));
        c.setAttribute('cy', s.cy.toFixed(1));
        c.setAttribute('r',  s.circleR.toFixed(1));
      } else {
        c.setAttribute('r', '0');
      }
    });
  }

  // ── Symbol clip ───────────────────────────────────────────────────────────
  function setSymbolClip(s, progress) {
    var poly = document.getElementById('poly-' + s.name);
    if (!poly) return;
    if (progress <= 0) { poly.setAttribute('points', '0,0 0,0 0,0 0,0'); return; }
    var pad = 10;
    var x0 = s.dispX - pad, y0 = s.dispY - pad;
    var x1 = s.dispX + s.dispW + pad, y1 = s.dispY + s.dispH + pad;
    if (progress >= 1) { poly.setAttribute('points', x0+','+y0+' '+x1+','+y0+' '+x1+','+y1+' '+x0+','+y1); return; }
    var entryA = s.entryAngle !== undefined ? s.entryAngle : Math.PI / 2;
    var exitA  = s.exitAngle  !== undefined ? s.exitAngle  : entryA;
    var diff = exitA - entryA;
    while (diff >  Math.PI) diff -= Math.PI * 2;
    while (diff < -Math.PI) diff += Math.PI * 2;
    var angle = entryA + diff * progress;
    var tx = Math.cos(angle), ty = Math.sin(angle);
    var px = Math.sin(angle), py = -Math.cos(angle);
    var cx = s.cx, cy = s.cy;
    var half = Math.max(s.dispW, s.dispH) * 0.7;
    var big  = half * 3;
    var wt   = -half + progress * half * 2;
    poly.setAttribute('points',
      (cx-big*tx+big*px).toFixed(1)+','+(cy-big*ty+big*py).toFixed(1)+' '+
      (cx-big*tx-big*px).toFixed(1)+','+(cy-big*ty-big*py).toFixed(1)+' '+
      (cx+wt*tx-big*px).toFixed(1)+','+(cy+wt*ty-big*py).toFixed(1)+' '+
      (cx+wt*tx+big*px).toFixed(1)+','+(cy+wt*ty+big*py).toFixed(1)
    );
  }

  // ── Binary search: path length at Y ──────────────────────────────────────
  function getLengthAtY(targetY) {
    var lo = 0, hi = pathLength;
    for (var i = 0; i < 16; i++) {
      var mid = (lo + hi) / 2;
      if (path.getPointAtLength(mid).y < targetY) lo = mid; else hi = mid;
    }
    return lo;
  }

  // ── Main scroll update ────────────────────────────────────────────────────
  function updatePath() {
    if (!pathLength || !symbolsReady) return;
    var scrollTop = window.scrollY;
    var vh        = window.innerHeight;
    var lastSym   = SYMS[SYMS.length - 1];
    var tipY      = scrollTop + vh * 0.75;
    var tipDrawn  = getLengthAtY(tipY);
    var drawn     = Math.min(tipDrawn, lastSym.pathLenAtEdge || tipDrawn);
    path.style.strokeDashoffset = Math.max(0, pathLength - Math.min(drawn, pathLength));
    SYMS.forEach(function (s) {
      var el = document.getElementById('sym-' + s.name);
      if (!el) return;
      if (scrollTop < s.revealStart) {
        el.style.setProperty('opacity', '0', 'important'); setSymbolClip(s, 0);
      } else if (scrollTop >= s.revealEnd) {
        el.style.setProperty('opacity', '1', 'important'); setSymbolClip(s, 1);
      } else {
        var raw = (scrollTop - s.revealStart) / (s.revealEnd - s.revealStart);
        var p   = raw < 0.5 ? 4*raw*raw*raw : 1 - Math.pow(-2*raw+2,3)/2;
        el.style.setProperty('opacity', '1', 'important'); setSymbolClip(s, p);
      }
    });
    updateLineMask();
  }

  // ── Scroll indicator ──────────────────────────────────────────────────────
  function updateIndicator() {
    if (!indicator) return;
    indicator.classList.toggle('is-hidden', window.scrollY > window.innerHeight * 0.22);
  }

  // ── Text word reveal ──────────────────────────────────────────────────────
  var SECTION_SUFFIXES = [
    '__section_mPBr6H', '__section_cfDt4x',
    '__section_ENb9An', '__section_yCMeKV',
  ];
  var GHOST_OPACITY = 0.15, FULL_OPACITY = 1.0, wordSpans = [];

  function initTextReveal() {
    wordSpans = [];
    SECTION_SUFFIXES.forEach(function (suffix) {
      var section = document.querySelector('[id$="' + suffix + '"]');
      if (!section) return;
      section.querySelectorAll('h2, .rte p').forEach(function (el) {
        if (el.dataset.wordSplit) return;
        el.dataset.wordSplit = '1';
        splitWordsInElement(el);
      });
    });
    SECTION_SUFFIXES.forEach(function (suffix) {
      var section = document.querySelector('[id$="' + suffix + '"]');
      if (!section) return;
      section.querySelectorAll('.enostos-word').forEach(function (s) { wordSpans.push(s); });
    });
  }

  function splitWordsInElement(el) {
    Array.from(el.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var text = node.textContent;
        if (!text.trim()) return;
        var fragment = document.createDocumentFragment();
        text.split(/(\s+)/).forEach(function (word) {
          if (/^\s+$/.test(word) || word === '') {
            fragment.appendChild(document.createTextNode(word));
          } else {
            var span = document.createElement('span');
            span.className = 'enostos-word';
            span.textContent = word;
            span.style.color = 'rgba(29, 28, 26, ' + GHOST_OPACITY + ')';
            span.style.transition = 'color 0.1s ease';
            fragment.appendChild(span);
          }
        });
        node.parentNode.replaceChild(fragment, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        splitWordsInElement(node);
      }
    });
  }

  function updateTextReveal() {
    if (!wordSpans.length) return;
    var vh = window.innerHeight, vw = window.innerWidth;
    var zoneBottom = vh * 1.20, zoneFull = vh * 0.50;
    var zoneHeight = zoneBottom - zoneFull, staggerPx = vh * 0.12;
    wordSpans.forEach(function (span) {
      var rect = span.getBoundingClientRect();
      var midY = rect.top + rect.height / 2;
      var midX = rect.left + rect.width / 2;
      var xF   = Math.max(0, Math.min(1, midX / vw));
      var effY = midY + xF * staggerPx;
      var prog = effY >= zoneBottom ? 0 : effY <= zoneFull ? 1 : (zoneBottom - effY) / zoneHeight;
      var e    = prog < 0.5 ? 4*prog*prog*prog : 1 - Math.pow(-2*prog+2,3)/2;
      var op   = e < 0.5
        ? GHOST_OPACITY + (0.45 - GHOST_OPACITY) * (e / 0.5)
        : 0.45 + (FULL_OPACITY - 0.45) * ((e - 0.5) / 0.5);
      span.style.color = 'rgba(29, 28, 26, ' + op.toFixed(3) + ')';
    });
  }

  // ── Hero parallax ─────────────────────────────────────────────────────────
  var PARALLAX_SPEED       = 0.25;
  var TITLE_PARALLAX_SPEED = 0.30;
  var heroSection = document.querySelector('[id$="__hero_irjTFL"]');
  var heroTitle   = document.querySelector('img[src*="the_land_that_remembers"]');

  function updateHeroParallax() {
    if (!heroSection) return;
    var scrollY = window.scrollY, vh = window.innerHeight;
    if (scrollY > vh * 1.2) return;
    heroSection.style.transform  = 'translateY(' + (-(scrollY * PARALLAX_SPEED)).toFixed(1) + 'px)';
    heroSection.style.willChange = 'transform';
    if (heroTitle) {
      heroTitle.style.transform  = 'translateY(' + (scrollY * TITLE_PARALLAX_SPEED).toFixed(1) + 'px)';
      heroTitle.style.willChange = 'transform';
    }
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  initTextReveal();
  buildPath();
  updatePath();
  updateIndicator();
  updateTextReveal();
  updateHeroParallax();
  initShellImage();
  initSwallowImage();
  initGroveImage();

  window.addEventListener('scroll', function () {
    updatePath(); updateIndicator(); updateTextReveal();
    updateHeroParallax(); updateShellImage(); updateSwallowImage(); updateGroveImage();
  }, { passive: true });

  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (Math.abs(window.innerWidth - lastW) > 10) {
      lastW = window.innerWidth;
      buildPath(); updatePath(); updateTextReveal();
      updateShellImage(); updateSwallowImage(); updateGroveImage();
    }
  }, { passive: true });
});